/*eslint no-script-url: 0 */
import React, { Component } from 'react';
import UploadImage from './Components/ImageManager/UploadImage';
import EditImage from './Components/ImageManager/EditImage';
import ResetImage from './Components/ImageManager/ResetImage';
import FramedSize from './Components/FrameSize/FramedSize';
import FramingOptions from './Components/FramingOptions';
import CartTotal from './Components/FramingOptions/CartTotal';
import AddToCart from './Components/Cart/AddToCart';
import Constants from './Config/Config';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Tour from 'reactour';
import Parser from 'html-react-parser';

const URL = Constants.URL.root+'/wp-content/themes/justpictureframing/data/frametour.json';

export default class FrameAreaRight extends Component {

	constructor(props, context) {
		super(props, context);
		this.updateHeight = this.updateHeight.bind(this);
		this.getSteps = this.getSteps.bind(this);
		this.updateSteps = this.updateSteps.bind(this);
		this.state = {
			steps: null,
            isTourOpen: false,
			runAPI: false
        }
	}

	getSteps() {
		var self = this;
		fetch(URL)
        .then(response => {
            if (!response.ok) {
                throw Error('Network request failed.')
            }
            return response;
        })
        .then(data => data.json())
        .then(data => {
            //console.log(data);
            self.updateSteps(data);
        }, (ex) => {
            self.setState({ error: ex.message });
        })
    }

    updateSteps(data) {
    	let stepsArray = [];
		data.map( ( item ) =>
        	stepsArray.push(
        		{
					selector: item.acf.selector,
                    content: function DemoHelperComponent() {
                        return (
                            <div className="reactour-step-content">
                                <div className="reactour-step-scroll">
                                    <h4>{Parser(item.title.rendered)}</h4>
                                    {Parser(item.content.rendered)}
                                </div>
                            </div>
                        );
                    }
        		}
        	)
        )
		this.setState({ steps: stepsArray, runAPI: true });
    }

	updateHeight() {
        this.props.dispatch({
			type: 'SET_STATE',
			state: {
				rightFrameHeight: this.divRef.clientHeight
			}
		})
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateHeight);
	}

	componentDidMount() {
        this.updateHeight();
        window.addEventListener("resize", this.updateHeight);
    }

	toggleSteps = () => {
		const { runAPI } = this.state
		if (!runAPI) {
			this.getSteps();
		}
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				showMeHow: true
			}
		})
    	this.setState(prevState => ({ isTourOpen: !prevState.isTourOpen }));
	}

	toggleStepsToFalse = () => {
    	this.setState({ isTourOpen: false });
  	}

  	getCurrentStep = (curr) => {
  		//console.log(`The current step is ${curr + 1}`)
  		let currentStep = curr + 1;
  		let inStep = false;
		if (currentStep === 3) {
  			currentStep = 'frames'
  			inStep = true
  		} else if (currentStep === 4) {
  			currentStep = 'mats'
  			inStep = true
  		} else if (currentStep === 5) {
  			currentStep = 'glass'
  			inStep = true
  		} else if (currentStep === 6) {
  			currentStep = 'printing'
  			inStep = true
  		} else if (currentStep === 7) {
  			currentStep = 'wallcolor'
  			inStep = true
  		} else if (currentStep === 8) {
  			currentStep = 'roomview'
  			inStep = true
  		}

  		if (inStep) {
			this.props.dispatch({
				type: 'SET_STATE',
				state: {
					selectedTab: currentStep
				}
			})
		}
  	}

  	disableBody = target => disableBodyScroll(target)
	enableBody = target => enableBodyScroll(target)

	render() {
	    return (
	    	<div className="col-sm-5">
				<div className="controls">
					<button onClick={this.toggleSteps} className={`btn default-btn guide-me-btn`}><i className="fas fa-info"></i> Show me how</button>
					{this.state.steps !== null &&
						<Tour
							steps={this.state.steps}
							isOpen={this.state.isTourOpen}
							onRequestClose={this.toggleSteps}
							rounded={4}
							onAfterOpen={this.disableBody}
	  						onBeforeClose={this.enableBody}
							getCurrentStep={curr => this.getCurrentStep(curr)}
							lastStepNextButton={`Finished`}
							nextButton={`Next`}
							prevButton={`Back`}
	  					/>
	  				}
				</div>
				<div className="cont_rgt" ref={element => this.divRef = element}>
					<div className="imageSizeWrapper">
						<div className="image-size-step">
							<FramedSize
								{...this.props} />
						</div>
						<div className="upload_image">
							<ul>
								<UploadImage
									{...this.props}
									toggleSteps={this.toggleStepsToFalse} />
								<EditImage
									{...this.props}
									toggleSteps={this.toggleStepsToFalse} />
								<ResetImage
									{...this.props} />
							</ul>
						</div>
					</div>
					<div className="summaryCheckoutWrapper">
						<FramingOptions {...this.props} />
						<CartTotal {...this.props} />
						<AddToCart {...this.props} />
					</div>
				</div>
			</div>
	    );
	}
}